<template>
  <div class="news-detail">
    <div class="top-nav">
      <nav-bar @moveTo="moveTo"></nav-bar>
    </div>
    <TopImg></TopImg>
    <div class="news-con">
      <div class="detail-con">
        <span class="news_time">
          <span class="line"></span>
          <span class="month">{{ month }}</span>
          <span class="day">{{ day }}</span>
          <span class="txt">日</span>
        </span>
        <div class="return" @click="jumpNewsList">
          <i class="arrow"></i>
          返回
        </div>
        <div class="content">
          <h3 class="tit" v-html="detail && detail.title" />
          <div class="detail-txt" v-html="detail && detail.content" />
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import TopImg from "./components/TopImg";
import NavBar from "./components/Nav";
import Footer from "./components/Footer";
import Common from "./components/Common";
import tool from '@/libs/utils.js'

export default {
  name: "NewsDetail",
  components: {
    TopImg,
    NavBar,
    Footer
  },
  mixins: [Common],
  data() {
    return {
      detailInfo: {},
      month: 0,
      day: 0,
      detail: {}
    };
  },
  created(){
    if(tool.checkOperaSys() !== 'pc'){
      let params = tool.getUrlParam();
      let url = `${process.env.VUE_APP_M_URL}`;
      if(!params.sn){
        window.location.href = url
        return;
      }
      const urlParams = tool.combinationUrlParam(params);
      window.location.href = `${url}detail?${urlParams}`
    }
  },
  mounted() {
    const query = this.$route.query;
    this.detailInfo = query;
    this.getNewsDetail();
  },
  methods: {
    jumpNewsList() {
      this.$router.push({ path: "/news" });
    },
    getDate(unixTime) {
      const time = new Date(unixTime);
      const month =
        time.getMonth() + 1 < 10
          ? "0" + (time.getMonth() + 1)
          : time.getMonth() + 1;
      const day = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
      return {
        month,
        day
      };
    },
    async getNewsDetail() {
      const { sn } = this.detailInfo;
      try {
        const { data } = await this.$api.getKMSConfig("article", { sn });
        this.detail = data;
        const date = data.inputtime ? data.inputtime : data.created;
        const { month, day } = this.getDate(date);
        this.month = month;
        this.day = day;
      } catch (error) {
        this.$toast(error?.desc || "Error");
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "./assets/css/mixin.less";
.news-detail {
  .top-nav {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
  }
  .news-con {
    .mixin_com(min-height, 1342);
    .mixin_com(padding-top, 38);

    background:
      #2d3651 url("~@/assets/images/news/bg.png") no-repeat center top /
      100%;
  }
  .detail-con {
    position: relative;
    .mixin_com(width, 1165);

    margin: 0 auto;
  }
  .content {
    .mixin_com(width, 960);
    .mixin_com(margin-left, 205);

    border-left: 1px solid #6683a6;
    /deep/ p,
    /deep/ div,
    /deep/ span,
    /deep/ li,
    /deep/ strong,
    /deep/ em,
    /deep/ i {
      font-size: 0.18rem !important;
      line-height: 1.5;
    }
    /deep/ img {
      display: block;
      max-width: 100% !important;
      height: auto !important;
      margin: 0 auto !important;
    }
  }
  .tit {
    .mixin_com(font-size, 36);
    .mixin_com(padding-bottom, 36);
    .mixin_com(padding-left, 40);

    color: #e5f4ff;
    text-align: center;
    border-bottom: 1px solid #6683a6;
  }
  .detail-txt {
    .mixin_com(margin-top, 30);
    .mixin_com(margin-bottom, 80);
    .mixin_com(margin-left, 20);
    .mixin_com(padding-bottom, 20);

    color: #c2d3e3;
  }
  .news_time {
    position: absolute;
    .mixin_com(top, 28);

    left: 0;
    .mixin_com(width, 152);
    .mixin_com(height, 120);

    font-family: FZFW-ZhuZiAOldMin-B--GB1-0;
    .mixin_com(font-size, 75);
    .mixin_com(line-height, 75);

    color: #a5b9d1;
  }
  .line {
    position: absolute;
    .mixin_com(bottom, 50);
    .mixin_com(left, 19);
    .mixin_com(width, 165);
    .mixin_com(height, 1);

    background: #a5b9d1;
    .transform(rotate(-45deg));
  }
  .month {
    position: absolute;
    .mixin_com(right, -20);
    .mixin_com(bottom, -22);

    font-style: italic;
  }
  .day {
    position: absolute;
    top: 0;
    left: 0;
    font-style: italic;
  }
  .txt {
    position: absolute;
    .mixin_com(top, -18);
    .mixin_com(right, 16);
    .mixin_com(font-size, 40);

    font-style: italic;
  }
  .return {
    position: absolute;
    .mixin_com(top, 200);
    .mixin_com(left, 30);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .mixin_com(width, 97);
    .mixin_com(height, 97);
    .mixin_com(font-size, 18);

    color: #081b34;
    cursor: pointer;
    background-color: #e5f4ff;
  }
  .arrow {
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
    border-top-color: transparent;
    border-right-color: #081b34;
    border-bottom-color: transparent;
    border-left-style: none;
    .mixin_com(border-top-width, 22);
    .mixin_com(border-bottom-width, 22);
    .mixin_com(border-right-width, 38);
    .mixin_com(margin-top, 2);
    .mixin_com(margin-bottom, 2);
  }
}
</style>
